import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { alerts_warning, alerts_danger, alerts_tip, alerts_hint, alerts_info } from '@paraglide/messages';
import styled from '@emotion/styled';
// Fixed import to use main lucide-react package to resolve TDZ initialization issues
import { AlertTriangle, XCircle, Info, Lightbulb, AlertCircle } from 'lucide-react';
// Use a function to avoid TDZ issues with icon components
const getAlertStyles = ()=>({
        warning: {
            bg: 'rgba(255, 152, 0, 0.1)',
            border: '#FF9800',
            icon: AlertTriangle
        },
        danger: {
            bg: 'rgba(244, 67, 54, 0.1)',
            border: '#F44336',
            icon: XCircle
        },
        tip: {
            bg: 'rgba(76, 175, 80, 0.1)',
            border: '#4CAF50',
            icon: Lightbulb
        },
        hint: {
            bg: 'rgba(33, 150, 243, 0.1)',
            border: '#2196F3',
            icon: Info
        },
        info: {
            bg: 'rgba(3, 169, 244, 0.1)',
            border: '#03A9F4',
            icon: AlertCircle
        }
    });
// Cache the styles to avoid recreating the object
const alertStyles = getAlertStyles();
const Container = styled.div`
  background: ${(props)=>alertStyles[props.type].bg};
  border: 1px solid ${(props)=>alertStyles[props.type].border};
  border-radius: var(--theme-radius-md, 8px);
  padding: var(--theme-spacing-lg, 24px);
  margin: var(--theme-spacing-lg, 24px) 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: ${(props)=>alertStyles[props.type].border};
    border-radius: 4px 0 0 4px;
  }
`;
const Title = styled.h4`
  color: var(--vscode-editor-foreground, var(--theme-text));
  margin: 0 0 var(--theme-spacing-sm, 8px) 0;
  font-size: var(--theme-typography-font-size-base, 1rem);
  font-weight: var(--theme-typography-font-weight-semibold, 600);
  display: flex;
  align-items: center;
  gap: var(--theme-spacing-sm, 8px);
  
  svg {
    color: ${(props)=>alertStyles[props.type].border};
  }
`;
const Content = styled.div`
  color: var(--vscode-editor-foreground, var(--theme-text));
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm, 0.875rem));
  line-height: 1.6;

  p {
    margin: 0 0 var(--theme-spacing-sm, 8px) 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  code {
    background-color: var(--vscode-textCodeBlock-background, rgba(0, 0, 0, 0.1));
    padding: 0.2em 0.4em;
    border-radius: var(--theme-radius-sm, 4px);
    font-size: 0.9em;
  }

  ul, ol {
    margin: var(--theme-spacing-sm, 8px) 0;
    padding-left: var(--theme-spacing-lg, 24px);
  }
`;
const getDefaultTitles = ()=>({
        warning: alerts_warning(),
        danger: alerts_danger(),
        tip: alerts_tip(),
        hint: alerts_hint(),
        info: alerts_info()
    });
const AlertBox = ({ type, title, children })=>{
    const Icon = alertStyles[type].icon;
    const defaultTitles = getDefaultTitles();
    const displayTitle = title || defaultTitles[type];
    return /*#__PURE__*/ _jsxs(Container, {
        type: type,
        children: [
            /*#__PURE__*/ _jsxs(Title, {
                type: type,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        size: 20
                    }),
                    displayTitle
                ]
            }),
            /*#__PURE__*/ _jsx(Content, {
                children: children
            })
        ]
    });
};
export default AlertBox;
